import { Button, Input, Label, Textarea } from "@repo/ui";

import { Container } from "@/components/container";

export default function Contact() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">Contact</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            We’re ready to help. Call us directly or send a message and we’ll respond promptly.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-2">
        <div className="space-y-6">
          <div>
            <div className="text-sm text-muted-foreground">Phone</div>
            <a href="tel:0804685545" className="text-lg font-medium text-accent">
              0804685545
            </a>
          </div>
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
            <div className="grid gap-2">
              <Label htmlFor="name">Name</Label>
              <Input id="name" name="name" placeholder="Your name" required />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" placeholder="you@company.com" required />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="message">Message</Label>
              <Textarea
                id="message"
                name="message"
                placeholder="How can we help?"
                rows={5}
                required
              />
            </div>
            <Button type="submit">Send message</Button>
          </form>
        </div>
        <div>
          <div className="aspect-[4/3] w-full overflow-hidden rounded-lg border">
            <iframe
              title="Bangkok Map"
              width="100%"
              height="100%"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387587.6608418863!2d100.27914638035558!3d13.724560173135576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29ed9f3894f7f%3A0x30100b25de24c40!2sBangkok%2C%20Thailand!5e0!3m2!1sen!2sth!4v1700000000000"
            ></iframe>
          </div>
        </div>
      </Container>
    </div>
  );
}
